import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const takeWhile = (source, predicate) => {
    if (predicate.length === 1) {
        return takeWhile1(source, predicate);
    }
    else {
        return takeWhile2(source, predicate);
    }
};
const takeWhile1 = (source, predicate) => {
    async function* iterator() {
        for await (const item of source) {
            if (predicate(item)) {
                yield item;
            }
            else {
                break;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
const takeWhile2 = (source, predicate) => {
    async function* iterator() {
        let index = 0;
        for await (const item of source) {
            if (predicate(item, index++)) {
                yield item;
            }
            else {
                break;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
